import { t } from 'localization/utils/t';

const TP = 'productTemplate.utils.specialTypeDataMap';

export const getSpecialTypeDataMap = () => ({
  vintage: {
    title: t(`${TP}.newVintage`, 'New / Vintage'),
    description: t(
      `${TP}.vintageDescription`,
      'Due to age, these sneakers may not be suitable for wear and will have additional defects to review',
    ),
  },
  custom: {
    title: t(`${TP}.custom`, 'New / Custom'),
    description: t(
      `${TP}.customDescription`,
      'Customs are exclusive sneakers created by a designer or customer whose photos should be reviewed prior to purchase.',
    ),
  },
  sample: {
    title: t(`${TP}.sample`, 'New / Sample'),
    description: t(
      `${TP}.newVintageDescription`,
      'Samples are sneaker prototypes created by brands pre-production. Their photos should be reviewed prior to purchase.',
    ),
  },
  id: {
    title: t(`${TP}.id`, 'New / ID'),
    description: t(
      `${TP}.idDescription`,
      'IDs are sneakers that are customized by customers and require you to review photos before purchasing',
    ),
  },
});
